
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 16.673c-.668 1.9-2.668 5.264-4.729 5.301-1.366.026-1.806-.794-3.368-.794-1.562 0-2.05.769-3.342.819C6.375 22.081 3 17.143 3 12.836 3 8.88 5.812 6.92 8.268 6.883c1.318-.023 2.562.871 3.365.871.807 0 2.318-1.075 3.907-.917.665.027 2.532.262 3.73 1.98-3.18 2.036-2.684 6.292.73 7.856zM15.561 2c-2.402.095-4.362 2.566-4.088 4.61 2.22.168 4.35-2.272 4.088-4.61z","fill":"#24201F"}})])
          )
        }
      }
    